// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1gicA","disabled":"FileBtn_disabled__3UKZU","warn":"FileBtn_warn__3x7Xe","fade":"FileBtn_fade__1i_xT"};